<div class="row no-gutters signup-page">
  <div class="col-md-6 col-sm-12 form-section">
    <h1 class="page-title">Welcome to the Future of AI Conversations</h1>
    <span class="page-subtitle">
      Talk to every top AI in one place. Welcome to the next era.
      <br>Already Have An Account? <a class="link-text" routerLink="/all-models/log-in" >Log In</a>
    </span>
    <form class="signup-form" [formGroup]="signupForm" (ngSubmit)="onSignup()">
      <p class="text-danger" *ngIf="emailLinkError">{{ emailLinkError }}</p>
      <p class="text-info" *ngIf="emailLinkInfo">{{ emailLinkInfo }}</p>
      <div class="form-row">
        <div class="form-group col-lg-6 col-md-12">
          <label for="firstname"></label>
          <input type="text" class="form-control" id="firstname" placeholder="First Name" formControlName="firstname">
        </div>
        <div class="form-group col-lg-6 col-md-12">
          <label for="lastname"></label>
          <input type="text" class="form-control" id="lastname" placeholder="Last Name" formControlName="lastname">
        </div>
       </div>
      <div class="form-row">
          <div class="form-group col-lg-6 col-md-12">
          <label for="country"></label>
          <input type="text" class="form-control" id="country" placeholder="Country" formControlName="country">
        </div>
  <div class="form-group col-lg-6 col-md-12">
  <label for="email"></label>
  <input type="email" class="form-control" id="email" placeholder="Email" formControlName="email">
  
  <!-- Inline validation messages -->
  <div *ngIf="signupForm.get('email')?.touched && signupForm.get('email')?.invalid" class="error-text">
    <div *ngIf="signupForm.get('email')?.errors?.['required']">
      Email is required.
    </div>
    <div *ngIf="signupForm.get('email')?.errors?.['email'] || signupForm.get('email')?.errors?.['pattern']">
      Please enter a valid email.
    </div>
     <!-- Email already in use -->
  <div class="error" *ngIf="emailInUse">
    This email is already in use.
  </div>
  </div>
</div>

       </div>
      <div class="form-row">
        <div class="form-group col-lg-6 col-md-12">
          <label for="password"></label>
          <input type="password" class="form-control" id="password" placeholder="Password" formControlName="password">
        </div>
          <div *ngIf="signupForm.get('password')?.touched && signupForm.get('password')?.invalid" class="error-text">
            <div *ngIf="signupForm.get('password')?.errors?.['required']">
              Password is required.
            </div>
            <div *ngIf="signupForm.get('password')?.errors?.['minlength']">
              Password must be at least 8 characters long.
            </div>
            <div *ngIf="signupForm.get('password')?.errors?.['pattern']">
              Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.
            </div>
            </div>

        <div class="form-group col-lg-6 col-md-12">
          <label for="confirmPassword"></label>
          <input type="password" class="form-control" id="confirmPassword" placeholder="Confirm Password" formControlName="confirmPassword">
        </div>
        <div *ngIf="passwordsDoNotMatch" class="error-text">
          Passwords Do Not Match
      </div>
       </div>
       <br>
       <div class="custom-control custom-checkbox">
         <input type="checkbox" class="custom-control-input" id="terms" formControlName="terms">
         <label class="custom-control-label" for="terms">
           <span class="custom-label">I Agree To The Terms And Privacy Policy.</span>
         </label>
         <span class="form-text help-text">
           By Creating An Account, You Agree To The Site <a href="#" class="link-text" target="_blank">Terms Of Service</a> And <a href="#" class="link-text" target="_blank">Privacy Policy</a>.
         </span>
       </div>
       <div class="form-call-to-actions">
         <button class="create-account-btn" type="submit" [disabled]="!signupForm.valid">Create Account</button>
       </div>
       <div class="form-call-to-actions">
         <button class="create-account-btn" type="button" (click)="onGoogleSignup()">Continue with Google</button>
       </div>
       <div class="form-call-to-actions">
         <button class="create-account-btn secondary-outline" type="button" (click)="onEmailLinkSignup()">Email me a sign-up link</button>
       </div>
       <div *ngIf="socialAuthError" class="error-text">
         {{ socialAuthError }}
       </div>
    </form>
  </div>
  <div class="col-md-6 d-none d-md-block image-section">
    <cc-image-shell class="signup-image add-overlay" animation="spinner" [mode]="'cover'" [src]="'/assets/imgs/authentication/clari.png'" [alt]="'app image'"></cc-image-shell>
  </div>
</div>
